import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Bulk variant of RemoveLocalizationValueCommand: removes a set of keys from
// every language as a SINGLE history entry, so a whole prune pass is one
// undo step.
export class PruneLocalizationKeysCommand extends CommandBase {
    keys: string[];

    constructor(keys: string[]) {
        super();
        this.keys = keys;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (this.keys.length === 0) {
            return false;
        }

        for (const language in data.localization) {
            for (const key of this.keys) {
                delete data.localization[language][key];
            }
        }

        return true;
    }
}
